<template>
  <!-- .profile -->
  <div class="container edit-user-template">
    <div class="page-header color-1-100">
      <h1>
        <template v-if="canEditDetails">
          Edit user details:
        </template>
        <template v-else-if="canEditPassword">
          Edit user password:
        </template>
        <template v-else>
          User profile:
        </template>
        {{ user.personal.first_name }} {{ user.personal.last_name }}
      </h1>
      <div class="profile-actions">
        <template v-if="this.user.personal.status !== 5">
          <button v-on:click.prevent="archiveProfile()" class="archive-profile archive-profile-custom background-1-20 color-2-100">
            <span class="delete-profile-icon color-1-100">
              <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                   viewBox="0 0 11.207 14.009" style="enable-background:new 0 0 11.207 14.009;" xml:space="preserve">
                <path id="XMLID_14_" class="st0" d="M9.806,0H1.401C0.628,0,0,0.628,0,1.401v11.207c0,0.772,0.628,1.401,1.401,1.401h8.405
                  c0.773,0,1.401-0.629,1.401-1.401V1.401C11.207,0.628,10.579,0,9.806,0z M9.094,5.697H6.946v2.148h2.148v2.148H6.946V7.845H4.798
                  V5.697h2.148V3.549H4.798V1.401h2.148v2.148h2.148V5.697z"/>
              </svg>
            </span>
            <template v-if="this.user.personal.enabled">
              Archive
            </template>
            <template v-else>
              Unarchive
            </template>
          </button>
          <button v-on:click.prevent="deleteProfile()" class="delete-profile delete-profile-custom background-1-20 color-2-100">
            <span class="delete-profile-icon color-1-100">
              <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                   viewBox="0 0 14.431 15.232" style="enable-background:new 0 0 14.431 15.232;" xml:space="preserve">
                <polygon id="XMLID_8_" class="st0" points="9.62,1.603 9.62,0 4.81,0 4.81,1.603 0,1.603 0,3.207 14.431,3.207 14.431,1.603 "/>
                <path id="XMLID_7_" class="st0" d="M1.603,4.008v9.621c0,0.884,0.719,1.603,1.603,1.603h8.017c0.884,0,1.603-0.72,1.603-1.603V4.008
                  H1.603z M6.414,12.026H4.81v-4.81h1.603V12.026z M9.62,12.026H8.017v-4.81H9.62V12.026z"/>
              </svg>
            </span>
            Delete
          </button>
        </template>
        <template v-if="this.user.personal.status === 5">
          <button v-on:click.prevent="approveUser(true)" class="delete-profile delete-profile-custom background-1-20 color-2-100">
            <span class="delete-profile-icon color-1-100">
              <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                   viewBox="0 0 174.239 174.239" style="enable-background:new 0 0 174.239 174.239;" xml:space="preserve">
                <g>
                  <path class="st0" d="M87.12,0C39.082,0,0,39.082,0,87.12s39.082,87.12,87.12,87.12s87.12-39.082,87.12-87.12S135.157,0,87.12,0z M87.12,159.305
                    c-39.802,0-72.185-32.383-72.185-72.185S47.318,14.935,87.12,14.935s72.185,32.383,72.185,72.185S126.921,159.305,87.12,159.305z"
                  />
                  <path class="st0" d="M131.55,59.413c-3.231-2.562-7.927-2.027-10.491,1.211L86.694,103.95L66.132,82.015c-2.812-3.014-7.543-3.155-10.555-0.345
                    c-3.009,2.825-3.162,7.55-0.34,10.555l26.481,28.251c1.415,1.512,3.389,2.363,5.447,2.363c0.102,0,0.204,0,0.309-0.005
                    c2.168-0.092,4.193-1.123,5.542-2.825L132.76,69.9C135.322,66.672,134.78,61.976,131.55,59.413z"/>
                </g>
              </svg>
            </span>
            Approve
          </button>
          <button v-on:click.prevent="approveUser(false)" class="delete-profile delete-profile-custom background-1-20 color-2-100">
            <span class="delete-profile-icon color-1-100">
              <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                   viewBox="0 0 174.239 174.239" style="enable-background:new 0 0 174.239 174.239;" xml:space="preserve">
                <g>
                  <path class="st0" d="M87.12,0C39.082,0,0,39.082,0,87.12s39.082,87.12,87.12,87.12s87.12-39.082,87.12-87.12S135.157,0,87.12,0z M87.12,159.305
                    c-39.802,0-72.185-32.383-72.185-72.185S47.318,14.935,87.12,14.935s72.185,32.383,72.185,72.185S126.921,159.305,87.12,159.305z"
                  />
                  <path class="st0" d="M120.83,53.414c-2.917-2.917-7.647-2.917-10.559,0L87.12,76.568L63.969,53.414c-2.917-2.917-7.642-2.917-10.559,0
                    s-2.917,7.642,0,10.559l23.151,23.153L53.409,110.28c-2.917,2.917-2.917,7.642,0,10.559c1.458,1.458,3.369,2.188,5.28,2.188
                    c1.911,0,3.824-0.729,5.28-2.188L87.12,97.686l23.151,23.153c1.458,1.458,3.369,2.188,5.28,2.188c1.911,0,3.821-0.729,5.28-2.188
                    c2.917-2.917,2.917-7.642,0-10.559L97.679,87.127l23.151-23.153C123.747,61.057,123.747,56.331,120.83,53.414z"/>
                </g>
              </svg>
            </span>
            Reject
          </button>
        </template>
      </div>
    </div>
    <div class="admin-breadcrumbs">
      <router-link class="dashboard dashboard-custom background-1-20 color-2-100" to="/">
          <span class="dashboard-icon color-1-100">
            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
              <g>
                <g>
                  <path class="st0" d="M501.333,490.667H10.667C4.779,490.667,0,495.445,0,501.333C0,507.221,4.779,512,10.667,512h490.667
                    c5.888,0,10.667-4.779,10.667-10.667C512,495.445,507.221,490.667,501.333,490.667z"/>
                </g>
              </g>
              <g>
                <g>
                  <path class="st0" d="M96,362.667H32c-5.888,0-10.667,4.779-10.667,10.667v128C21.333,507.221,26.112,512,32,512h64
                    c5.888,0,10.667-4.779,10.667-10.667v-128C106.667,367.445,101.888,362.667,96,362.667z M85.333,490.667H42.667V384h42.667
                    V490.667z"/>
                </g>
              </g>
              <g>
                <g>
                  <path class="st0" d="M224,256h-64c-5.888,0-10.667,4.779-10.667,10.667v234.667c0,5.888,4.779,10.667,10.667,10.667h64
                    c5.888,0,10.667-4.779,10.667-10.667V266.667C234.667,260.779,229.888,256,224,256z M213.333,490.667h-42.667V277.333h42.667
                    V490.667z"/>
                </g>
              </g>
              <g>
                <g>
                  <path class="st0" d="M352,298.667h-64c-5.888,0-10.667,4.779-10.667,10.667v192c0,5.888,4.779,10.667,10.667,10.667h64
                    c5.888,0,10.667-4.779,10.667-10.667v-192C362.667,303.445,357.888,298.667,352,298.667z M341.333,490.667h-42.667V320h42.667
                    V490.667z"/>
                </g>
              </g>
              <g>
                <g>
                  <path class="st0" d="M480,170.667h-64c-5.888,0-10.667,4.779-10.667,10.667v320c0,5.888,4.779,10.667,10.667,10.667h64
                    c5.888,0,10.667-4.779,10.667-10.667v-320C490.667,175.445,485.888,170.667,480,170.667z M469.333,490.667h-42.667V192h42.667
                    V490.667z"/>
                </g>
              </g>
              <g>
                <g>
                  <path class="st0" d="M64,192c-23.531,0-42.667,19.136-42.667,42.667c0,23.531,19.136,42.667,42.667,42.667
                    c23.531,0,42.667-19.136,42.667-42.667C106.667,211.136,87.531,192,64,192z M64,256c-11.776,0-21.333-9.579-21.333-21.333
                    c0-11.755,9.557-21.333,21.333-21.333s21.333,9.579,21.333,21.333C85.333,246.421,75.776,256,64,256z"/>
                </g>
              </g>
              <g>
                <g>
                  <path class="st0" d="M192,85.333c-23.531,0-42.667,19.136-42.667,42.667c0,23.531,19.136,42.667,42.667,42.667s42.667-19.136,42.667-42.667
                    C234.667,104.469,215.531,85.333,192,85.333z M192,149.333c-11.776,0-21.333-9.579-21.333-21.333
                    c0-11.755,9.557-21.333,21.333-21.333s21.333,9.579,21.333,21.333C213.333,139.755,203.776,149.333,192,149.333z"/>
                </g>
              </g>
              <g>
                <g>
                  <path class="st0" d="M320,128c-23.531,0-42.667,19.136-42.667,42.667c0,23.531,19.136,42.667,42.667,42.667
                    c23.531,0,42.667-19.136,42.667-42.667C362.667,147.136,343.531,128,320,128z M320,192c-11.776,0-21.333-9.579-21.333-21.333
                    c0-11.755,9.557-21.333,21.333-21.333s21.333,9.579,21.333,21.333C341.333,182.421,331.776,192,320,192z"/>
                </g>
              </g>
              <g>
                <g>
                  <path class="st0" d="M448,0c-23.531,0-42.667,19.136-42.667,42.667c0,23.531,19.136,42.667,42.667,42.667
                    c23.531,0,42.667-19.136,42.667-42.667C490.667,19.136,471.531,0,448,0z M448,64c-11.776,0-21.333-9.579-21.333-21.333
                    c0-11.755,9.557-21.333,21.333-21.333s21.333,9.579,21.333,21.333C469.333,54.421,459.776,64,448,64z"/>
                </g>
              </g>
              <g>
                <g>
                  <path class="st0" d="M432.939,57.728c-4.16-4.16-10.923-4.16-15.083,0l-82.773,82.773c-4.16,4.16-4.16,10.923,0,15.083
                    c2.091,2.069,4.821,3.115,7.552,3.115c2.709,0,5.44-1.024,7.531-3.115l82.773-82.773
                    C437.099,68.651,437.099,61.888,432.939,57.728z"/>
                </g>
              </g>
              <g>
                <g>
                  <path class="st0" d="M294.208,146.048l-68.523-19.541c-5.739-1.664-11.563,1.664-13.163,7.339c-1.621,5.675,1.664,11.563,7.317,13.184
                    l68.523,19.541c0.981,0.277,1.963,0.405,2.923,0.405c4.651,0,8.917-3.051,10.261-7.744
                    C303.168,153.579,299.883,147.669,294.208,146.048z"/>
                </g>
              </g>
              <g>
                <g>
                  <path class="st0" d="M175.36,141.291c-3.669-4.608-10.368-5.355-14.976-1.707l-80.427,64.128c-4.608,3.691-5.376,10.389-1.685,14.997
                    c2.112,2.645,5.227,4.011,8.341,4.011c2.325,0,4.672-0.768,6.635-2.304l80.427-64.128
                    C178.283,152.597,179.051,145.899,175.36,141.291z"/>
                </g>
              </g>
            </svg>
          </span>
        Go to Dashboard
      </router-link>
      <router-link class="all-users all-users-custom background-1-20 color-2-100"
                   :to="{name: getUserRole === 'gm' ? 'users' : 'ca-users'}"
                   v-if="getUserRole !== 'cu' && user.personal.company">
          <span class="all-users-icon color-1-100">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 32.053 34.5" style="enable-background:new 0 0 32.053 34.5;" xml:space="preserve">
              <g id="XMLID_10_">
                <path id="XMLID_20_" class="st0" d="M4.75,0C2.131,0,0,2.131,0,4.75S2.131,9.5,4.75,9.5S9.5,7.369,9.5,4.75S7.369,0,4.75,0z"/>
                <path id="XMLID_21_" class="st0" d="M15.178,6.25h15.375c0.829,0,1.5-0.671,1.5-1.5s-0.671-1.5-1.5-1.5H15.178
                  c-0.829,0-1.5,0.671-1.5,1.5S14.349,6.25,15.178,6.25z"/>
                <path id="XMLID_22_" class="st0" d="M4.75,12.375c-2.619,0-4.75,2.131-4.75,4.75s2.131,4.75,4.75,4.75s4.75-2.131,4.75-4.75
                  S7.369,12.375,4.75,12.375z"/>
                <path id="XMLID_23_" class="st0" d="M30.553,15.625H15.178c-0.829,0-1.5,0.671-1.5,1.5s0.671,1.5,1.5,1.5h15.375
                  c0.829,0,1.5-0.671,1.5-1.5S31.381,15.625,30.553,15.625z"/>
                <path id="XMLID_24_" class="st0" d="M4.75,25C2.131,25,0,27.131,0,29.75s2.131,4.75,4.75,4.75s4.75-2.131,4.75-4.75
                  S7.369,25,4.75,25z"/>
                <path id="XMLID_25_" class="st0" d="M30.553,28.25H15.178c-0.829,0-1.5,0.671-1.5,1.5s0.671,1.5,1.5,1.5h15.375
                  c0.829,0,1.5-0.671,1.5-1.5S31.381,28.25,30.553,28.25z"/>
              </g>
            </svg>
          </span>
        Back to all users
      </router-link>
      <button v-on:click.prevent="impersonateUser()"
         v-if="getUserRole === 'gm' && (this.user.personal.role && this.user.personal.role.slug !== 'gm')"
         class="impersonate-user background-1-20">Impersonate this user</button>
    </div>
    <div class="flex-block">
      <div class="content-right-section anchors">
        <div class="sticky-anchors background-1-40-before" tabindex="-1">
          <div class="anchor-item anchor-item-custom color-1-20 details color-1-100"
               :class="[{ 'active  color-1-100': activeSection === 'userDetails' }]">
            <button @click.prevent="goToPageSection('userDetails')">
                <span class="anchor-item-icon color-1-40">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="0 0 20 18" style="enable-background:new 0 0 20 18;" xml:space="preserve">
                    <path id="XMLID_1_" class="st0" d="M18,2h-5.185C12.401,0.838,11.302,0,10,0S7.599,0.838,7.185,2H2C0.897,2,0,2.897,0,4v12
                      c0,1.103,0.897,2,2,2h16c1.103,0,2-0.897,2-2V4C20,2.897,19.103,2,18,2z M6,6c1.105,0,2,0.896,2,2s-0.895,2-2,2S4,9.104,4,8
                      S4.895,6,6,6z M3,14c0-1.841,1.159-3,3-3c1.841,0,3,1.159,3,3H3z M10,4C9.449,4,9,3.551,9,3c0-0.551,0.449-1,1-1s1,0.449,1,1
                      C11,3.551,10.551,4,10,4z M17,14h-6v-2h6V14z M17,10h-6V8h6V10z"/>
                  </svg>
                </span>
              <template v-if="canEditDetails === false">User details</template>
              <template v-else>Edit user details</template>
            </button>
          </div>
          <div class="anchor-item anchor-item-custom color-1-20 password" :class="[{ 'active  color-1-100': activeSection === 'userPassword' }]">
            <button @click.prevent="goToPageSection('userPassword')">
                <span class="anchor-item-icon color-1-40">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="0 0 20 20" style="enable-background:new 0 0 20 20;" xml:space="preserve">
                    <path id="XMLID_1_" class="st0" d="M10,0C4.477,0,0,4.477,0,10s4.477,10,10,10c5.523,0,10-4.477,10-10S15.523,0,10,0z M11.378,10.65
                      L12,15H8l0.622-4.35C7.662,10.149,7,9.157,7,8c0-1.656,1.344-3,3-3c1.656,0,3,1.344,3,3C13,9.157,12.338,10.149,11.378,10.65z"/>
                  </svg>
                </span>
              <template v-if="canEditPassword === false">User password</template>
              <template v-else>Edit user password</template>
            </button>
          </div>
          <div class="anchor-item anchor-item-custom color-1-20 data" :class="[{ 'active  color-1-100': activeSection === 'userData' }]">
              <span class="anchor-item-icon color-1-40">
                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 19.99 21" style="enable-background:new 0 0 19.99 21;" xml:space="preserve">
                  <g>
                    <path class="st0" d="M11,14H9c-2.757,0-5,2.239-5,4.996V21h12v-2.004C16,16.239,13.756,14,11,14z"/>
                    <path class="st0" d="M6.343,12.523c-1.249-1.757-1.099-4.21,0.475-5.784c1.754-1.755,4.609-1.755,6.364,0
                      c1.574,1.573,1.724,4.027,0.475,5.784c0.629,0.259,1.212,0.608,1.733,1.028c1.702-2.526,1.439-5.992-0.793-8.226
                      c-2.534-2.535-6.658-2.533-9.193,0c-2.232,2.234-2.495,5.7-0.793,8.226C5.131,13.13,5.714,12.781,6.343,12.523z"/>
                    <path class="st0" d="M3.512,14.663C2.535,13.31,2,11.697,2,9.995c0-2.137,0.832-4.146,2.343-5.657
                      c3.119-3.119,8.194-3.119,11.313,0c2.809,2.81,3.08,7.2,0.83,10.324c0.445,0.563,0.803,1.194,1.06,1.878
                      c3.406-3.923,3.254-9.886-0.476-13.617c-3.898-3.897-10.243-3.897-14.142,0C1.041,4.812,0,7.325,0,9.995
                      c0,2.434,0.872,4.729,2.452,6.546C2.709,15.858,3.067,15.226,3.512,14.663z"/>
                    <circle class="st0" cx="10" cy="9.995" r="3"/>
                  </g>
                </svg>
              </span>
            <button @click.prevent="goToPageSection('userData')">User Data</button>
          </div>
        </div>
      </div>
      <div class="content-left-section">
        <div class="content-section content-section__bordered border-1-20 profile-section no-margin-top"
             tabindex="-1"
             ref="userDetails">
          <section class="personal-info">
            <h3 class="content-section-title color-1-100 background-1-100-before">
              <template v-if="canEditDetails === false">User details</template>
              <template v-else>Edit user details</template>
            </h3>
            <button v-on:click.prevent="openEditDetails()"
                    class="edit-details edit-details-custom border-1-40 color-2-100" v-if="canEditDetails === false">
                <span class="edit-icon color-1-100">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="0 0 12.955 12.921" style="enable-background:new 0 0 12.955 12.921;" xml:space="preserve">
                    <g id="XMLID_1_">
                      <path id="XMLID_4_" class="st0" d="M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921
                        c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"/>
                      <path id="XMLID_5_" class="st0" d="M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316
                        L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0
                        l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"/>
                    </g>
                  </svg>
                </span>
              Edit
            </button>
            <div class="form-group form-group-half">
              <div class="form-element featured-image">
                <div class="user-featured-image">
                  <span class="form-label color-2-63">Profile image</span>
                  <label class="form-label color-2-63 form-label--file-upload"
                         style="width: 100%;"
                         v-show="!isThumbnailFileUploaded && canEditDetails === true">
                    <div class="upload-text">+Upload image</div>
                    <input
                      type="file"
                      id="uploadThumbnail"
                      name="Image"
                      data-vv-as='"Image"'
                      value.sync="user.personal.image"
                      :disabled="canEditDetails === false"
                      v-validate.reject="veeValidateFileUploadRules"
                      @change="onThumbnailFileChange($event)"
                      class="form-control form-control--file" />
                  </label>
                  <div class="user-featured-image-icon"
                       v-show="!isThumbnailFileUploaded && canEditDetails === false">
                    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user"
                         class="svg-inline--fa fa-user fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg"
                         viewBox="0 0 448 512"><path fill="currentColor" d="M224 256c70.7 0 128-57.3 128-128S294.7 0
                             224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2
                             288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"></path>
                    </svg>
                  </div>
                  <div id="thumbnailFilePreview" v-if="isThumbnailFileUploaded" v-bind:style="{ backgroundImage: 'url(' + user.personal.image + ')' }" ></div>
                  <button
                    type="button"
                    v-if="isThumbnailFileUploaded && canEditDetails === true"
                    @click="removeThumbnail"
                    class="btn btn--remove-element">
                    <span class="btn__text">-Remove image</span>
                  </button>
                </div>
              </div>
              <div class="form-element">
                <label for="new-user-name" class="form-label color-2-63">First name</label>
                <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                       :class="[{ 'has-error': errors.has('First name'), 'is-locked': !canEditDetails, 'is-blocked': consentStatus === 0 }]"
                       :disabled="canEditDetails === false || consentStatus === 0"
                       data-lpignore="true"
                       v-on:keyup="fieldChange"
                       v-model="user.personal.first_name"
                       id="new-user-name"
                       v-validate="'required'"
                       name="First name">
                <span class="form-field-error" v-if="this.errors.has('First name')">{{ this.errors.first('First name') }}</span>
              </div>
              <div class="form-element">
                <label for="new-user-surname" class="form-label color-2-63">Last name</label>
                <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                       :class="[{ 'has-error': errors.has('Last name'), 'is-locked': !canEditDetails, 'is-blocked': consentStatus === 0 }]"
                       :disabled="canEditDetails === false || consentStatus === 0"
                       data-lpignore="true"
                       id="new-user-surname"
                       v-validate="'required'"
                       name="Last name"
                       v-on:keyup="fieldChange"
                       v-model="user.personal.last_name"/>
                <span class="form-field-error" v-if="this.errors.has('Last name')">{{ this.errors.first('Last name') }}</span>
              </div>
              <div class="form-element">
                <label for="new-user-email" class="form-label color-2-63">Email address</label>
                <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                       :class="[{ 'has-error': errors.has('Email'), 'is-locked': !canEditDetails, 'is-blocked': consentStatus === 0 }]"
                       :disabled="canEditDetails === false || consentStatus === 0"
                       data-lpignore="true"
                       id="new-user-email"
                       v-validate="'required|email'"
                       name="Email"
                       v-on:keyup="fieldChange"
                       v-model="user.personal.email"/>
                <span class="form-field-error" v-if="this.errors.has('Email')">{{ this.errors.first('Email') }}</span>
              </div>
              <div class="form-element">
                <label for="new-user-phone" class="form-label color-2-63">Phone number</label>
                <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                       :class="[{ 'has-error': errors.has('Phone number'), 'is-locked': !canEditDetails }]"
                       :disabled="canEditDetails === false"
                       data-lpignore="true"
                       id="new-user-phone"
                       name="Phone number"
                       v-on:keyup="fieldChange"
                       v-model="user.personal.phone"/>
                <span class="form-field-error" v-if="this.errors.has('Phone number')">{{ this.errors.first('Phone number') }}</span>
              </div>
            </div>
            <div class="form-group form-group-half">
              <div class="form-element">
                <label for="new-user-company-role" class="form-label color-2-63">User type (role)</label>
                <v-select class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                          :class="[{ 'is-locked': !canEditDetails }]"
                          :disabled="canEditDetails === false || (getUserRole !== 'gm' && getUserRole !== 'ca' && getUserRole !== 'ta')"
                          :searchable=true
                          v-on:keyup="fieldChange"
                          v-model="user.personal.role"
                          :options="getRolesForSelect"
                          v-validate="'required'"
                          data-vv-name="User type"
                          name="User type"
                          id="new-user-company-role"/>
                <span class="form-field-error" v-if="this.errors.has('User type')">{{ this.errors.first('User type') }}</span>
              </div>
              <div class="form-element" v-if="this.isStakeholder === true">
                <label for="new-user-company-stakeholder_type" class="form-label color-2-63">Stakeholder type</label>
                <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                       :class="[{ 'has-error': errors.has('Stakeholder type'), 'is-locked': !canEditDetails }]"
                       :disabled="canEditDetails === false"
                       data-lpignore="true"
                       v-on:keyup="fieldChange"
                       v-model="user.personal.stakeholder_type"
                       data-vv-name="Stakeholder type"
                       name="Stakeholder type"
                       id="new-user-company-stakeholder_type"/>
              </div>
              <div class="form-element" v-if="getUserRole === 'gm'">
                <label for="new-user-company-name" class="form-label color-2-63">Company name</label>
                <v-select class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                          :class="[{ 'has-error': errors.has('Company'), 'is-locked': !canEditDetails, 'is-blocked': (user.personal.role && user.personal.role.slug === 'gm') }]"
                          :disabled="canEditDetails === false || (user.personal.role && user.personal.role.slug === 'gm')"
                          :searchable=true
                          v-on:keyup="fieldChange"
                          v-model="user.personal.company"
                          :options="getCompaniesForSelect"
                          v-validate="'required'"
                          data-vv-name="Company name"
                          name="Company name"
                          id="new-user-company-name"/>
                <span class="form-field-error" v-if="this.errors.has('Company name')">{{ this.errors.first('Company name') }}</span>
              </div>
              <div class="form-element">
                <label for="new-user-company-function" class="form-label color-2-63">Function</label>
                <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                       :class="[{ 'has-error': errors.has('Function'), 'is-locked': !canEditDetails }]"
                       :disabled="canEditDetails === false"
                       data-lpignore="true"
                       id="new-user-company-function"
                       name="Function"
                       v-on:keyup="fieldChange"
                       v-model="user.personal.function"/>
                <span class="form-field-error" v-if="this.errors.has('Function')">{{ this.errors.first('Function') }}</span>
              </div>
              <div class="form-element">
                <label for="new-user-company-title" class="form-label color-2-63">Job title</label>
                <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                       :class="[{ 'has-error': errors.has('Job title'), 'is-locked': !canEditDetails }]"
                       :disabled="canEditDetails === false"
                       data-lpignore="true"
                       id="new-user-company-title"
                       name="Job title"
                       v-on:keyup="fieldChange"
                       v-model="user.personal.job_title"/>
                <span class="form-field-error" v-if="this.errors.has('Job title')">{{ this.errors.first('Job title') }}</span>
              </div>
            </div>
            <div class="form-group form-group-half" v-if="getUserRole === 'gm'">
              <div class="form-element">
                <label for="new-user-id" class="form-label color-2-63">User id</label>
                <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                       :class="[{ 'is-blocked': canEditDetails, 'is-locked': !canEditDetails }]"
                       disabled="disabled"
                       data-lpignore="true"
                       id="new-user-id"
                       v-validate="'required'"
                       v-model="user.personal.id"/>
              </div>
            </div>
          </section>
          <div class="clearfix"></div>
          <div class="update-data update-data__details" v-if="canEditDetails">
            <button v-on:click.prevent="closeEditDetails()" class="cancel-edit background-2-7 color-2-100 cancel-edit-details">Discard changes</button>
            <button v-on:click.prevent="updateProfileDetails()" class="save-edit background-1-100 color-2-100 save-edit-details">Save changes</button>
          </div>
        </div>

        <div class="content-section content-section__bordered border-1-20 profile-section"
             tabindex="-1"
             ref="userPassword"
             :class="[{ 'content-section__closed': canEditPassword === false }]">
          <section class="password-info">
            <h3 class="content-section-title color-1-100 background-1-100-before">
              <template v-if="canEditPassword === false">User password</template>
              <template v-else>Edit user password</template>
            </h3>
            <button v-on:click.prevent="openEditPassword()"
                    class="edit-password edit-password-custom border-1-40 color-2-100" v-if="canEditPassword === false">
                <span class="edit-icon color-1-100">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="0 0 12.955 12.921" style="enable-background:new 0 0 12.955 12.921;" xml:space="preserve">
                    <g id="XMLID_1_">
                      <path id="XMLID_4_" class="st0" d="M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921
                        c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"/>
                      <path id="XMLID_5_" class="st0" d="M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316
                        L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0
                        l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"/>
                    </g>
                  </svg>
                </span>
              Edit
            </button>
            <div class="form-group" v-if="canEditPassword">
              <div class="form-group form-group-half">
                <div class="form-element">
                  <label for="new-password-edit" class="form-label color-2-63">New password</label>
                  <input class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :class="[{ 'has-error': passwordError }]"
                         :disabled="canEditPassword === false"
                         ref="passwordInput"
                         data-lpignore="true"
                         id="new-password-edit"
                         type="password"
                         name="New password"
                         v-validate="'required'"
                         v-on:keyup="fieldChange"
                         v-model="user.personal.plainPassword.first">
                  <span class="form-field-error" v-if="this.errors.has('New password')">{{ this.errors.first('New password') }}</span>
                </div>
              </div>
              <div class="form-group form-group-half">
                <div class="form-element">
                  <label for="retype-password" class="form-label color-2-63">Retype new password</label>
                  <input class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :class="[{ 'has-error': passwordError }]"
                         :disabled="canEditPassword === false"
                         data-lpignore="true"
                         type="password"
                         id="retype-password"
                         name="Retype new password"
                         data-vv-as="Retype new password"
                         v-validate="'required|confirmed:passwordInput'"
                         v-on:keyup="fieldChange"
                         v-model="user.personal.plainPassword.second">
                  <span class="form-field-error" v-if="this.errors.has('Retype new password')">{{ this.errors.first('Retype new password') }}</span>
                </div>
              </div>
              <div class="password-helper-text color-2-63">
                The new password can't be the same as the old password.<br/>
                Please use a strong password. It must contain at least 9 characters that include capital letters, lower case letters and numbers.
              </div>
            </div>
            <div class="update-data update-data__password" v-if="canEditPassword">
              <button v-on:click.prevent="closeEditPassword()" class="cancel-edit background-2-7 color-2-100 cancel-edit-password">Discard changes</button>
              <button v-on:click.prevent="updateProfilePassword()" class="save-edit background-1-100 color-2-100 save-edit-password">Save changes</button>
            </div>
          </section>
          <div class="clearfix"></div>
        </div>
        <div class="content-section consent-section"
             tabindex="-1"
             ref="userData">
          <section class="password-info">
            <h3 class="content-section-title color-1-100 background-1-100-before">User data</h3>
            <div class="consent-data" :class="this.consentStatus === 1 ? 'consent-given' : 'consent-not-given'">
              <template v-if="this.consentStatus === 1">
                User provided their consent to store and process their data under the GDPR settings on {{ this.convertDate(this.consentDate, '.') }}.
              </template>
              <template v-else>
                <template v-if="this.consentDate">
                  User withdrawn their consent to allow us to use their data under the GDPR settings on {{ this.convertDate(this.consentDate, '.') }}. <br/>
                  User has to provide consent so he can use all the website functionalities.
                </template>
                <template v-else>
                  User haven't provided yet with consent to store and use their data, under the GDPR settings.<br/>
                  User has to provide consent so they can use all the website functionalities.
                </template>
              </template>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
  <!-- END:.profile -->
</template>

<script>
  import api from '@/api'
  import { mapActions, mapGetters } from 'vuex'
  import AppSelect from '@/components/admin/common/Select'

  export default {
    name: 'profile',
    data () {
      return {
        infMsgTitle: '',
        infMsgDescription: '',
        infMsgClass: '',
        messageDisplay: false,
        canEditDetails: false,
        canEditPassword: false,
        passwordError: false,
        confOpened: null,
        user: {
          personal: {
            id: '',
            first_name: '',
            last_name: '',
            email: '',
            company: null,
            role: null,
            job_title: null,
            enabled: null,
            status: null,
            current_password: '',
            plainPassword: {
              first: '',
              second: ''
            },
            image: ''
          }
        },
        confirmation: {
          action: '',
          isShown: false,
          articleId: null,
          i: null,
          style: {
            top: '100px'
          }
        },
        canLeave: false,
        next: null,
        initialData: {},
        isChanged: false,
        isStakeholder: false,
        consentStatus: 0,
        consentDate: null,
        activeSection: 'userDetails',
        isThumbnailFileUploaded: false
      }
    },
    computed: {
      ...mapGetters([
        'selectedHightCont',
        'getCompaniesForSelect',
        'getRolesForSelect',
        'BlueYelBlue',
        'blackYelBlack',
        'getUserRole',
        'getConfData',
        'isRegularUser'
      ]),
      infoStyles () {
        let updatedStyle = Object.assign(this.BlueYelBlue, {})
        if (+this.selectedHightCont === 1) {
          updatedStyle.backgroundColor = '#000'
        }
        return updatedStyle
      },
      veeValidateFileUploadRules () {
        return {
          required: false,
          mimes: 'image/*'
        }
      }
    },
    methods: {
      ...mapActions([
        'clearConfAction',
        'getRoles',
        'getCompanies',
        'setInformationMsg',
        'initConfAction',
        'authLogout'
      ]),
      openEditPassword: function () {
        this.canEditPassword = true
      },
      openEditDetails: function () {
        this.canEditDetails = true
      },
      closeEditPassword: function () {
        this.user.personal.current_password = ''
        this.user.personal.plainPassword = {
          first: '',
          second: ''
        }
        this.canEditPassword = false
      },
      closeEditDetails: function () {
        this.user.personal = this.initialData
        this.canEditDetails = false
        this.errors.clean()
      },
      closeMsg: function () {
        this.errors.clear()
      },
      deleteProfile () {
        this.confOpened = 'delete'
        this.initConfAction({
          actionName: 'removeUserById'
        })
      },
      deleteProfileConfirmed () {
        let id = this.userId
        this.$http.delete(api.URLS.user + '/' + id, api.headersAuthSettings)
            .then((res) => {
              let userName = this.user.personal.first_name + ' ' + this.user.personal.last_name
              if (userName === ' ') {
                userName = this.user.personal.email
              }
              this.infMsgTitle = userName + '\'s profile was successfully deleted.'
              this.infMsgDescription = 'All information related to this profile was removed from our database. We’ll only keep the information related to this profile into our system logs.'
              this.infMsgClass = 'success'
              this.setInformationMsg({
                isShown: true,
                title: this.infMsgTitle,
                text: this.infMsgDescription,
                className: this.infMsgClass
              })
              this.goToUserList(id)
            })
            .catch((err) => {
              this.disableAPI = false
              this.infMsgTitle = 'Error. We can\'t delete this user because '
              for (let error in err.body.error.exception) {
                this.infMsgTitle += err.body.error.exception[error].message + ' '
              }
              if (this.getUserRole === 'gm') {
                this.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.'
              } else {
                this.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.'
              }
              this.infMsgClass = 'error'
              this.setInformationMsg({
                isShown: true,
                title: this.infMsgTitle,
                text: this.infMsgDescription,
                className: this.infMsgClass
              })
            })
        this.getConfData.actionConfirmed = false
      },
      approveUser (approved) {
        let userData = {
          id: this.userId,
          approved: approved
        }
        this.$http.put(api.URLS.profile, userData, api.headersAuthSettings)
          .then((res) => {
            let actionText = approved ? 'approved' : 'rejected'
            this.disableAPI = false
            this.infMsgTitle = res.body.first_name + ' ' + res.body.last_name + '\'s profile was successfully ' + actionText
            this.infMsgDescription = 'Please note all actions are being logged.'
            this.infMsgClass = 'success'
            this.setInformationMsg({
              isShown: true,
              title: this.infMsgTitle,
              text: this.infMsgDescription,
              className: this.infMsgClass
            })
            this.getProfileData()
          })
          .catch((err) => {
            this.disableAPI = false
            let actionText = approved ? 'approve' : 'reject'
            this.infMsgTitle = 'Error. We can\'t ' + actionText + ' this user because '
            for (let error in err.body.error.exception) {
              this.infMsgTitle += err.body.error.exception[error].message + ' '
            }
            if (this.getUserRole === 'gm') {
              this.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.'
            } else {
              this.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.'
            }
            this.infMsgClass = 'error'
            this.setInformationMsg({
              isShown: true,
              title: this.infMsgTitle,
              text: this.infMsgDescription,
              className: this.infMsgClass
            })
            this.getProfileData()
          })
      },
      impersonateUser () {
        this.confOpened = 'impersonate'
        this.initConfAction({
          actionName: 'impersonateUserById',
          actionId: (this.user.personal.first_name + ' ' + this.user.personal.last_name) !== ' '
            ? this.user.personal.first_name + ' ' + this.user.personal.last_name
            : this.user.personal.email
        })
      },
      impersonateUserConfirmed () {
        let userData = JSON.parse(localStorage.getItem('userData'))
        userData.id = this.user.personal.id
        userData.userRole = this.user.personal.role.slug
        userData.company = this.user.personal.company.id
        userData.firstName = this.user.personal.first_name
        userData.lastName = this.user.personal.last_name
        localStorage.setItem('impersonated', this.user.personal.email)
        localStorage.setItem('userData', JSON.stringify(userData))
        this.$store.commit('authLoginSetUserRole', this.user.personal.role.slug)
        this.$store.commit('changeImpersonate', this.user.personal.email)
        this.$store.commit('changeAuthUserData', userData)
        let props = this.$router.resolve({
          name: this.isRegularUser ? 'user-app' : 'knowledge-base'
        })
        location.href = props.href
      },
      archiveProfile () {
        this.confOpened = 'archive'
        this.initConfAction({
          actionName: 'changeUserStatus',
          userStatus: this.user.personal.enabled ? 0 : 1
        })
      },
      archiveProfileConfirmed () {
        let userData = {
          id: this.userId,
          enabled: !this.user.personal.enabled
        }
        this.$http.put(api.URLS.profile, userData, api.headersAuthSettings)
            .then((res) => {
              let actionText = res.body.enabled ? 'Unarchived' : 'Archived'
              this.disableAPI = false
              this.infMsgTitle = res.body.first_name + ' ' + res.body.last_name + '\'s profile was successfully ' + actionText
              if (!res.body.enabled) {
                this.infMsgDescription = 'Archived users will still appear in your organization, but they will not be able to access the application. You can unarchive a user and re-enable their access at any time.'
              } else {
                this.infMsgDescription = 'This will grant the user access to the application. Viewing rights and privileges depend on their user type (role).'
              }
              this.infMsgClass = 'success'
              this.setInformationMsg({
                isShown: true,
                title: this.infMsgTitle,
                text: this.infMsgDescription,
                className: this.infMsgClass
              })
              this.getProfileData()
            })
            .catch((err) => {
              this.disableAPI = false
              this.infMsgTitle = 'Error. We can\'t archive this user because '
              for (let error in err.body.error.exception) {
                this.infMsgTitle += err.body.error.exception[error].message + ' '
              }
              if (this.getUserRole === 'gm') {
                this.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.'
              } else {
                this.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.'
              }
              this.infMsgClass = 'error'
              this.setInformationMsg({
                isShown: true,
                title: this.infMsgTitle,
                text: this.infMsgDescription,
                className: this.infMsgClass
              })
              this.getProfileData()
            })
        this.getConfData.actionConfirmed = false
      },
      fieldChange () {
        this.isChanged = true
      },
      getProfileData () {
        this.$http.put(api.URLS.profile, {id: this.userId}, api.headersAuthSettings).then((res) => {
          let personal = this.user.personal
          // set page user data
          personal.id = res.body.id
          personal.first_name = res.body.first_name
          personal.last_name = res.body.last_name
          personal.email = res.body.email
          personal.phone = res.body.phone
          personal.function = res.body.function
          personal.job_title = res.body.job_title
          personal.status = res.body.status
          personal.enabled = res.body.enabled
          if (res.body.image) {
            personal.image = (api.serverURL + '/uploads/images/users/' + res.body.image)
            this.isThumbnailFileUploaded = true
          }
          if (res.body.company) {
            personal.company = {
              id: res.body.company.id,
              label: res.body.company.name,
              value: res.body.company.id
            }
          }
          personal.role = {
            id: res.body.role.id,
            label: res.body.role.name,
            value: res.body.role.id,
            slug: res.body.role.slug
          }
          personal.stakeholder_type = res.body.stakeholder_type
          personal.plainPassword = {
            first: '',
            second: ''
          }
          // set consent data
          this.consentStatus = res.body.consent_status
          this.consentDate = res.body.consent_updated
          // set initial data
          this.initialData.id = personal.id
          this.initialData.first_name = personal.first_name
          this.initialData.last_name = personal.last_name
          this.initialData.email = personal.email
          this.initialData.phone = personal.phone
          this.initialData.function = personal.function
          this.initialData.job_title = personal.job_title
          this.initialData.enabled = personal.enabled
          this.initialData.status = personal.status
          this.initialData.company = personal.company
          this.initialData.role = personal.role
          this.initialData.stakeholder_type = personal.stakeholder_type
          this.initialData.image = personal.image
          this.initialData.plainPassword = {
            first: '',
            second: ''
          }
          document.title = personal.first_name + ' ' + personal.last_name + '\'s profile details | Clear Assured'
          if (window._paq) {
            window._paq.push(['setCustomUrl', location.pathname])
            window._paq.push(['setDocumentTitle', document.title])
            window._paq.push(['trackPageView'])
          }
          // if (window.ga) {
          //   window.ga('set', 'contentGroup1', this.$router.currentRoute.name === 'ca-edit-user' ? 'DASHBOARD_AREA' : 'ADMINISTRATION_AREA')
          //   window.ga('send', 'pageview', {
          //     'page': location.pathname,
          //     'location': location.href,
          //     'title': document.title
          //   })
          // }
        }).catch((err) => {
          if (err.status === 404) {
            let props = this.$router.resolve({
              name: 'error'
            })
            document.location = props.href
          }
          if (err.status === 401) {
            this.authLogout()
          }
        })
      },
      updateProfileDetails () {
        if (this.disableAPI) return
        this.$validator.validateAll()
        if (this.errors.items.length) return
        let userData = {
          id: this.userId,
          firstName: this.user.personal.first_name,
          lastName: this.user.personal.last_name,
          email: this.user.personal.email,
          phone: this.user.personal.phone,
          function: this.user.personal.function,
          jobTitle: this.user.personal.job_title,
          company: this.user.personal.company,
          role: this.user.personal.role,
          stakeholderType: this.user.personal.stakeholder_type,
          image: this.user.personal.image
        }
        this.disableAPI = true
        this.$http.put(api.URLS.profile, userData, api.headersAuthSettings)
            .then((res) => {
              this.disableAPI = false
              this.infMsgTitle = res.body.first_name + ' ' + res.body.last_name + '\'s profile details was successfully updated.'
              this.infMsgDescription = 'When you update a user\'s profile, they are sent an email with the details of the change and who did it. Please note these actions are being logged.'
              this.infMsgClass = 'success'
              this.setInformationMsg({
                isShown: true,
                title: this.infMsgTitle,
                text: this.infMsgDescription,
                className: this.infMsgClass
              })
              this.getProfileData()
              this.canEditDetails = !this.canEditDetails
            })
            .catch((err) => {
              this.disableAPI = false
              this.infMsgTitle = 'Error. We were not able to update this user because '
              for (let error in err.body.error.exception) {
                this.infMsgTitle += err.body.error.exception[error].message + ' '
              }
              this.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.'
              this.infMsgClass = 'error'
              this.setInformationMsg({
                isShown: true,
                title: this.infMsgTitle,
                text: this.infMsgDescription,
                className: this.infMsgClass
              })
              this.getProfileData()
            })
      },
      updateProfilePassword () {
        if (this.disableAPI) return
        this.$validator.validate('New password', this.user.personal.plainPassword.first)
        this.$validator.validate('Retype new password', this.user.personal.plainPassword.second)
        let firstPassword = this.user.personal.plainPassword.first
        let secondPassword = this.user.personal.plainPassword.second
        if (!firstPassword || !secondPassword) return
        if (firstPassword !== secondPassword) {
          this.passwordError = true
          this.infMsgTitle = 'Passwords doesn\'t match!'
          this.infMsgDescription = 'New password and Retype new password fields doesn\'t match. Please recheck!'
          this.infMsgClass = 'error'
          this.setInformationMsg({
            isShown: true,
            title: this.infMsgTitle,
            text: this.infMsgDescription,
            className: this.infMsgClass
          })
          return
        }
        let userData = {}
        userData = {
          id: this.userId,
          newPassword: firstPassword
        }
        this.disableAPI = true
        this.$http.put(api.URLS.profile, userData, api.headersAuthSettings)
            .then((res) => {
              this.disableAPI = false
              this.infMsgTitle = res.body.first_name + ' ' + res.body.last_name + '\'s profile password was successfully updated.'
              this.infMsgDescription = 'When you update a user\'s profile, they are sent an email with the details of the change and who did it. Please note these actions are being logged.'
              this.infMsgClass = 'success'
              this.setInformationMsg({
                isShown: true,
                title: this.infMsgTitle,
                text: this.infMsgDescription,
                className: this.infMsgClass
              })
              this.passwordError = false
              this.canEditPassword = false
              this.getProfileData()
            })
            .catch((err) => {
              this.getProfileData()
              this.disableAPI = false
              this.infMsgTitle = 'Error. We were not able to update this user because '
              for (let error in err.body.error.exception) {
                this.infMsgTitle += err.body.error.exception[error].message + ' '
              }
              this.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.'
              this.infMsgClass = 'error'
              this.setInformationMsg({
                isShown: true,
                title: this.infMsgTitle,
                text: this.infMsgDescription,
                className: this.infMsgClass
              })
              this.passwordError = false
              this.canEditPassword = false
            })
        this.messageDisplay = true
      },
      goToUserList (id) {
        let props = this.$router.resolve({
          name: 'users',
          params: {id: id}
        })
        this.$router.push(props.href)
      },
      convertDate (payload, delimetr) {
        if (!payload) return
        let date = new Date(payload)
        let fullYear = date.getFullYear()
        let month = date.getMonth() + 1
        let day = date.getDate()
        function toDoubleDigit (num) {
          return num.toString().length < 2 ? '0' + num : num.toString()
        }
        return toDoubleDigit(day) + delimetr + toDoubleDigit(month) + delimetr + fullYear
      },
      goToPageSection (ref) {
        let element = this.$refs[ref]
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
          setTimeout(function () {
            element.focus()
          })
        }
      },
      posY (elm) {
        let test = elm
        let top = 0
        while (test !== null && test.tagName.toLowerCase() !== 'body') {
          top += test.offsetTop
          test = test.offsetParent
        }
        return top
      },
      scrollY () {
        if (window.pageYOffset) {
          return window.pageYOffset
        }
        return Math.max(document.documentElement.scrollTop, document.body.scrollTop)
      },
      isScrolledIntoView (elem) {
        let docViewTop = this.scrollY()
        let docViewBottom = docViewTop + window.outerHeight
        let elemTop = this.posY(elem) + 300
        let elemBottom = elemTop + elem.offsetHeight
        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop))
      },
      handleScroll () {
        let sections = this.$refs
        for (let index in sections) {
          let section = sections[index]
          if (section && this.isScrolledIntoView(section)) {
            this.activeSection = index
          }
        }
      },
      onThumbnailFileChange (e) {
        let self = this
        var input = document.getElementById('uploadThumbnail')
        if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif)$/i)) {
          this.isThumbnailFileUploaded = true
          var reader = new FileReader()
          reader.onload = function (e) {
            self.user.personal.image = e.target.result
          }
          reader.readAsDataURL(input.files[0])
        }
      },
      removeThumbnail () {
        var input = document.getElementById('uploadThumbnail')
        input.value = null
        this.isThumbnailFileUploaded = false
        this.user.personal.image = null
      }
    },
    beforeRouteLeave (to, from, next) {
      if (this.user.personal.first_name !== this.initialData.first_name ||
          this.user.personal.last_name !== this.initialData.last_name ||
          this.user.personal.email !== this.initialData.email) {
        this.confirmation.isShown = true
        this.next = next
      } else {
        next()
      }
    },
    components: {
      AppSelect
    },
    watch: {
      'getConfData.actionConfirmed' (value) {
        if (value) {
          if (this.confOpened === 'delete') this.deleteProfileConfirmed()
          if (this.confOpened === 'archive') this.archiveProfileConfirmed()
          if (this.confOpened === 'impersonate') this.impersonateUserConfirmed()
          this.clearConfAction()
        }
      },
      'user.personal.role' (value) {
        if (value && value.slug === 'sh') {
          this.isStakeholder = true
        } else {
          this.isStakeholder = false
        }
      }
    },
    created () {
      this.userId = this.$route.params.id
      window.addEventListener('scroll', this.handleScroll)
    },
    beforeMount () {
      this.getRoles()
      this.getCompanies()
    },
    mounted () {
      this.getProfileData()
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>

<style src='@/assets/scss/components/profile.scss' lang='scss' />



// WEBPACK FOOTER //
// EditUser.vue?72a00562